//CRN_20260508 - Riskline Country Risk Levels service (reads from SureSim backend)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, Observable, of, throwError } from 'rxjs';
import { CountryRiskLevelDTO } from '../../models/system/riskline/riskline-country-risk-level.dto';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RisklineCountryRiskLevelsService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getAllRiskLevels(): Observable<CountryRiskLevelDTO[]> {
    try {
      return this.httpClientService
             .get<CountryRiskLevelDTO[]>(environment.eSimApi
                                         + eSimApiPaths.RiskIntelligence
                                         + '/'
                                         + eSimApiPaths.RiskIntelligenceCountryRiskLevels)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineCountryRiskLevelsService.getAllRiskLevels() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of([]);
    }
  }

  public getRiskLevelForCountry(isoCode: string): Observable<CountryRiskLevelDTO> {
    try {
      if (!isoCode || isoCode.trim()=='')
        throw new Error('RisklineCountryRiskLevelsService.getRiskLevelForCountry() - isoCode is required');

      return this.httpClientService
             .get<CountryRiskLevelDTO>(environment.eSimApi
                                       + eSimApiPaths.RiskIntelligence
                                       + '/'
                                       + eSimApiPaths.RiskIntelligenceCountryRiskLevels
                                       + '/'
                                       + isoCode)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineCountryRiskLevelsService.getRiskLevelForCountry() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
